export const RELATIONSHIPS = [
  { value: "self", label: "Self" },
  { value: "parent", label: "Parent" },
  { value: "sibling", label: "Sibling" },
  { value: "relative", label: "Relative" },
  { value: "other", label: "Other" },
];

const heights = [];
for (let i = 54; i <= 84; i += 1) heights.push(`${Math.floor(i / 12)}' ${i % 12}"`);
export const HEIGHTS = heights;

export const COMPLEXIONS = ["Very fair", "Fair", "Wheatish", "Wheatish brown", "Dark"];
export const RELIGIONS = ["Hindu", "Muslim", "Christian", "Sikh", "Jain", "Buddhist", "Parsi", "Other"];
export const MARITAL_STATUSES = ["Never married", "Divorced", "Widowed", "Awaiting divorce", "Separated"];
export const GANAS = ["Deva", "Manushya", "Rakshasa", "Don't know"];
export const RASHIS = [
  "Mesh (Aries)", "Vrishabh (Taurus)", "Mithun (Gemini)", "Kark (Cancer)", "Simha (Leo)", "Kanya (Virgo)",
  "Tula (Libra)", "Vrishchik (Scorpio)", "Dhanu (Sagittarius)", "Makar (Capricorn)", "Kumbh (Aquarius)",
  "Meen (Pisces)", "Don't know",
];
export const BLOOD_GROUPS = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-", "Don't know"];
export const FOOD_HABITS = [
  { value: "vegetarian", label: "Vegetarian" },
  { value: "non_vegetarian", label: "Non-vegetarian" },
  { value: "eggetarian", label: "Eggetarian" },
  { value: "other", label: "Other" },
];
export const OCCUPATIONS = [
  "Job holder", "Business", "Self-employed", "Professional (Doctor, Lawyer, CA etc.)", "Student", "Not working", "Other",
];
export const JOB_HOLDER = "Job holder";
export const FAMILY_TYPES = [
  { value: "joint", label: "Joint" },
  { value: "nuclear", label: "Nuclear" },
  { value: "other", label: "Other" },
];

export const labelOf = (list, value) => {
  const hit = list.find((o) => (typeof o === "string" ? o === value : o.value === value));
  if (!hit) return value;
  return typeof hit === "string" ? hit : hit.label;
};
